import { Injectable } from '@angular/core';
import { OnDevicesAPISubscription } from 'ngx-core-services';
import { ViewportScroller } from '@angular/common';
import { Router } from '@angular/router';
import { ToastService, ErrorSinkService } from 'ngx-zcs-components';

import { SolarmanService } from './solarman.service';
import { InternetChannelInstance } from './internet-channel.instance';

const FACTORY_DEBUG = { ENABLED: true };
const factLog = (msg: string) => FACTORY_DEBUG.ENABLED && console.log(`[Modbus:ChannelFactory] ${msg}`);

/**
 * Factory service for creating independent InternetChannelInstance objects.
 * Each instance has isolated state (command, subscriptions, responses) enabling
 * parallel multi-device communication over Internet (Solarman).
 *
 * Usage (via ChannelHandler):
 *   const channel = channelHandler.getOrCreateChannel(deviceId, CommunicationChannelType.Internet);
 *   await channel.open({ serial: deviceId });
 */
@Injectable({
  providedIn: 'root',
})
export class InternetChannelFactory {
  constructor(
    private readonly onDevicesAPISubscription: OnDevicesAPISubscription,
    private readonly router: Router,
    private readonly solarmanService: SolarmanService,
    private readonly toastService: ToastService,
    private readonly viewportScroller: ViewportScroller,
    private readonly errorSink: ErrorSinkService,
  ) {}

  create(): InternetChannelInstance {
    factLog('Creating new InternetChannelInstance');
    return new InternetChannelInstance(
      this.onDevicesAPISubscription,
      this.router,
      this.solarmanService,
      this.toastService,
      this.viewportScroller,
      this.errorSink,
    );
  }
}
